export default __webpack_public_path__ + "static/media/location_outline.4b2e2745.svg";